const state = {
    token: null,
    userInfo: null
};

const mutations = {
    SET_TOKEN(state, token) {
        state.token = token;
    },
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo;
    },
    CLEAR_AUTH(state) {
        state.token = null;
        state.userInfo = null;
    }
};

const actions = {
    setToken({commit}, token) {
        commit('SET_TOKEN', token);
    },
    setUserInfo({commit}, userInfo) {
        commit('SET_USER_INFO', userInfo);
    },
    clearAuth({commit}) {
        commit('CLEAR_AUTH');
    }
};

const getters = {
    token: state => state.token,
    userInfo: state => state.userInfo
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
